import { redirectToOriginApplication } from 'actionCreators/navigation';

function submitSaveExitScreen(values) {
  return new Promise((resolve) => {
    // do any additional work after we submit the form here...

    // If we've got this far, no errors occurred while submitting.
    // Therefore, we can resolve() the Promise successfully.
    resolve();
  });
}

function submitSaveExitScreenSuccess(result, dispatch, props) {
  dispatch(redirectToOriginApplication());
}

function submitSaveExitScreenFail(result, dispatch, props) {}

export {
  submitSaveExitScreen as onSubmit,
  submitSaveExitScreenSuccess as onSubmitSuccess,
  submitSaveExitScreenFail as onSubmitFail
};
